import * as Yup from "yup";

const BusinessNameSchema = Yup.object().shape({
  descripcion: Yup.string().required("Nombre de Medio de Contacto es requerido"),
});

export default BusinessNameSchema;
